import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, updateDoc } from 'firebase/firestore';
import { storage, db } from './firebase-init';

/**
 * Upload a PDF blob to Firebase Storage
 * Path: jobDocuments/{year}/{contractNumber}/{docType}.pdf
 */
export async function uploadJobPDF(contractNumber, docType, blob) {
  const year = new Date().getFullYear();
  const path = `jobDocuments/${year}/${contractNumber}/${docType}.pdf`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, blob, { contentType: 'application/pdf' });
  return await getDownloadURL(storageRef);
}

/**
 * Save PDF URL to both job documents (fire and forget — never blocks the download)
 */
export async function savePDFUrlToJob(twpJobId, cutlistJobId, docType, url) {
  const updates = { [`pdfUrls.${docType}`]: url };
  const promises = [];
  if (twpJobId)     promises.push(updateDoc(doc(db, 'jobs', twpJobId), updates));
  if (cutlistJobId) promises.push(updateDoc(doc(db, 'cutlistJobs', cutlistJobId), updates));
  await Promise.all(promises);
}

/**
 * Upload estimate PDF to Firebase Storage
 * Path: estimates/{estimateId}/estimate.pdf
 */
export async function uploadEstimatePDF(estimateId, blob) {
  const path = `estimates/${estimateId}/estimate.pdf`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, blob, { contentType: 'application/pdf' });
  return await getDownloadURL(storageRef);
}